import {CARD} from '../actions/card';

const filesOferta = [
    {
        id: 1,
        file: '/files/oferta_ip_rudenko.pdf',
    },
    {
        id: 2,
        file: '/files/oferta_ip_staseva.pdf',
    },
    {
        id: 3,
        file: '/files/oferta_ip_svetacheva.pdf',
    },
    {
        id: 4,
        file: '#',
    },
];

export const InitialState = {
    // data
    mainData: {}, // общий массив данных с инфой о картах

    clubOferta: null, // документ оферты для выбранного клуба

    accessClubs: [], // список id клубов, куда будем ходить

    studentStatus: false, // скидка для студентов
    dayDiscount: false, // дневная скидка
    familyDiscount: false, // семейный тариф
    installmentDiscount: false,

    duration: 12, // кол-во месяцев абонемента
    freezing: 0, // кол-во месяцев заморозки

    custom: false, // карта настроена вручную
    customDuration: 12,
    customFreezing: 0,
    customStudentStatus: false, // скидка для студентов
    customDayDiscount: false, // дневная скидка
    customFamilyDiscount: false, // семейный тариф

    customerData: null, // данные клиента
    secondCustomerData: null, // данные второго клиента (для семейной карты)

    prolongation: false, // продление абонемента
    prolongationDiscount: 0, // размер скидки за продление

    promocode: null, // промокод

    urlPdf: '', // ссылка на итоговый pdf
    resultCard: null, // выбранная карта из предложенных

    clubIsChecked: false,

    milleniumAdded: false,

    gameleadDiscount: 0, //скидка из колеса фортуны
    gameleadPresent: '', //подарок из колеса фортуны

    widgetDiscount: 0, //скидка из кастомного виджета на сайте
    widgetPresent: '', //подарок из кастомного виджета на сайте

    fitbonDiscountPercent: 0,
    fitbonDiscount: 0,

    phoneChecked: false,
    phoneCheckedValue: '',

    orderCode: null
};

// REDUCERS
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = InitialState, action) {
    switch (action.type) {
        case CARD.GET_MAIN_DATA:
            return Object.assign({}, state, {
                mainData: action.mainData
            });

        case CARD.SET_ACCESS_CLUBS_STR:
            let strClubs = '';

            if (state.accessClubs.length) {
                if (state.accessClubs.length === state.mainData.length) {
                    strClubs = 'Все клубы'
                } else {
                    state.accessClubs.forEach(el => {
                        state.mainData.forEach(item => {
                            if (el === item.id) {
                                strClubs += `${item.title_club.split(' ')[1]}, `;
                            }
                        })
                    })

                    strClubs = strClubs.slice(0, -2);
                }
            }

            return Object.assign({}, state, {
                accessClubsStr: strClubs
            });

        case CARD.SET_STUDENT_STATUS:
            return Object.assign({}, state, {
                studentStatus: action.status
            });

        case CARD.SET_DAY_STATUS:
            return Object.assign({}, state, {
                dayDiscount: action.status
            });

        case CARD.SET_FAMILY_STATUS:
            return Object.assign({}, state, {
                familyDiscount: action.status
            });

        case CARD.SET_NEXT_STEP:
            return Object.assign({}, state, {
                nextStepOnTwoScreen: action.step
            });

        case CARD.SET_DISABLED_SETTING_SCREEN:
            return Object.assign({}, state, {
                disabledSettingScreen: action.step
            });

        case CARD.CHANGE_DURATION:
            return Object.assign({}, state, {
                duration: action.countMonth
            });

        case CARD.CHANGE_FREEZING:
            return Object.assign({}, state, {
                freezing: action.countMonth
            });

        case CARD.SET_RESULT_CARD:
            return Object.assign({}, state, {
                resultCard: action.card,
                duration: action.card.base_months,
                freezing: action.card.base_freezing_months,
                customDuration: action.card.base_months,
                customFreezing: action.card.base_freezing_months
            });

        case CARD.SET_CUSTOMER_DATA:
            return Object.assign({}, state, {
                customerData: action.data
            })

        case CARD.SET_SECOND_CUSTOMER_DATA:
            return Object.assign({}, state, {
                secondCustomerData: action.data
            })

        case CARD.SET_PROLONGATION:
            return Object.assign({}, state, {
                prolongation: action.prolongation,
                prolongationDiscount: parseInt(action.prolongationDiscount)
            });

        case CARD.SET_ONLINE:
            return Object.assign({}, state, {
                online: action.online
            });

        case CARD.RESET_STEP:
            if (action.step === 1) {
                // reset state for 2-5 step
                return Object.assign({}, state, {
                    // 2
                    custom: false,
                    duration: 12,
                    freezing: 0,
                    countVisits: null,
                    timeVisits: 1,
                    oneVisit: false,
                    nextStepOnTwoScreen: 3,
                    disabledSettingScreen: null,
                    // 3
                    resultCard: null,
                    online: false,
                    // prolongation: false
                    promocode: null,
                    gameleadDiscount: 0,
                    gameleadPresent: '',
                    widgetDiscount: 0,
                    widgetPresent: '',
                    fitbonDiscount: 0,
                    fitbonDiscountPercent: 0
                });
            } else if (action.step === 2) {
                // reset state for 3-5 step
                return Object.assign({}, state, {
                    // prolongation: false
                });
            } else if (action.step === 3) {
                // reset state for 4-5 step
                return Object.assign({}, state, {
                    // 5

                    // prolongation: false
                });
            } else if (action.step === 4) {
                // reset state for 5 step
                return Object.assign({}, state, {
                    // 5

                    // prolongation: false
                });
            }

            return false;

        case CARD.SET_PDF:
            return Object.assign({}, state, {
                urlPdf: action.urlPdf
            });

        case CARD.SET_CHECKED_CLUB:
            return Object.assign({}, state, {
                clubIsChecked: action.clubIsChecked,
            });

        case CARD.SET_CUSTOM_STATUS:
            if (action.custom) {
                if (action.restore) {
                    return Object.assign({}, state, {
                        custom: action.custom,
                        duration: state.customDuration,
                        freezing: state.customFreezing,
                        familyDiscount: state.customFamilyDiscount,
                        studentStatus: state.customStudentStatus,
                        dayDiscount: state.customDayDiscount
                    })
                } else {
                    return Object.assign({}, state, {
                        custom: action.custom
                    })
                }
            } else {
                return Object.assign({}, state, {
                    custom: action.custom,
                    customDuration: state.duration,
                    customFreezing: state.freezing,
                    duration: state.resultCard.base_months,
                    freezing: state.resultCard.base_freezing_months,
                    customFamilyDiscount: state.familyDiscount,
                    customStudentStatus: state.studentStatus,
                    customDayDiscount: state.dayDiscount,
                    familyDiscount: false,
                    studentStatus: false,
                    dayDiscount: false
                })
            }

        case CARD.SET_PROMOCODE:
            return Object.assign({}, state, {
                promocode: action.data
            });

        case CARD.SWITCH_MILLENIUM_CLUB:
            return Object.assign({}, state, {
                milleniumAdded: action.data
            });

        case CARD.SWITCH_INSTALLMENT_DISCOUNT:
            return Object.assign({}, state, {
                installmentDiscount: action.data
            });

        case CARD.SET_GAMELEAD_DISCOUNT:
            return Object.assign({}, state, {
                gameleadDiscount: action.discount
            });

        case CARD.SET_GAMELEAD_PRESENT:
            return Object.assign({}, state, {
                gameleadPresent: action.present
            });
           
        case CARD.SET_WIDGET_DISCOUNT:
            return Object.assign({}, state, {
                widgetDiscount: action.discount
            });
        case CARD.SET_WIDGET_PRESENT:
            return Object.assign({}, state, {
                widgetPresent: action.present
            });

        case CARD.SET_PHONE_CHECKED:
            return Object.assign({}, state, {
                phoneChecked: action.status,
                phoneCheckedValue: action.phone
            });

        case CARD.SET_ORDER_CODE:
            return Object.assign({}, state, {
                orderCode: action.code
            });

        case CARD.SET_FITBON_DISCOUNT_PERCENT:
            return Object.assign({}, state, {
                fitbonDiscountPercent: action.discount
            });

        case CARD.SET_FITBON_DISCOUNT:
            return Object.assign({}, state, {
                fitbonDiscount: action.discount
            });

        default:
            return state
    }
}